<script setup lang="ts">
const { modalType } = storeToRefs(useLayoutStore());
const { selectModalType } = useLayoutStore();
</script>

<template>
  <div :class="$style.tabs">
    <button
      class="px-4 text-xs font-semibold"
      :class="modalType == 'login' ? 'text-primary' : 'text-texts'"
      @click="selectModalType('login')"
    >
      {{ $t('auth.login.login') }}
    </button>

    <button
      class="px-4 text-xs font-semibold"
      :class="modalType == 'register' ? 'text-primary' : 'text-texts'"
      @click="selectModalType('register')"
    >
      {{ $t('auth.register.title') }}
    </button>
  </div>
</template>

<style module lang="scss">
.tabs {
  @apply flex sm:hidden items-center justify-center min-w-full pb-6 pt-4 text-auth-bg-inputs border-solid border-b border-auth-bg-inputs;
}
</style>
